//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/createTheme/shape.js
var e = { borderRadius: 4 };
//#endregion
export { e as default };

//# sourceMappingURL=index30.js.map